import { useGetLocalStorageKeyWithUserId } from '../../../../../../shared/hooks'

const BANNER_FILTERS_LOCALSTORAGE_KEY = 'banner-filters'

export const useBannerFiltersLocalStorageKeyWithUserId = (id: string) => useGetLocalStorageKeyWithUserId(`${BANNER_FILTERS_LOCALSTORAGE_KEY}-${id}`)
